import { createRouter, createWebHistory } from 'vue-router';
import HomeView from '@/views/HomeView.vue';
import WinnersView from '@/views/WinnersView.vue';
import SubmissionReviewView from '@/views/SubmissionReviewView.vue';
import EventWaiverView from '@/views/EventWaiverView.vue';
import WaiverReviewView from '@/views/WaiverReviewView.vue';
import BlankLayout from '@/layouts/BlankLayout.vue';
import DefaultLayout from '@/layouts/DefaultLayout.vue';
import NationalWinnersView from './views/NationalWinnersView.vue';

const currentDate = new Date();
const nationalWinnersDate = new Date('2025-06-23T00:00:00-14:00');
const winnersDate = new Date('2025-05-12T00:00:00-04:00');

const shouldRenderWinner = () => {
  if (currentDate >= nationalWinnersDate) {
    return NationalWinnersView;
  }

  if (currentDate >= winnersDate) {
    return WinnersView;
  }

  return HomeView;
};

const isWinners = (currentDate >= nationalWinnersDate) || (currentDate >= winnersDate);

const routes = [
  {
    path: '/',
    name: 'home',
    redirect: () => '/honda',
    component: shouldRenderWinner(),
    meta: {
      layout: DefaultLayout,
      winners: isWinners,
    },
  },
  {
    path: '/honda',
    name: 'honda',
    component: shouldRenderWinner(),
    meta: {
      layout: DefaultLayout,
      winners: isWinners,
    },
  },
  {
    path: '/acura',
    name: 'acura',
    component: shouldRenderWinner(),
    meta: {
      layout: DefaultLayout,
      winners: isWinners,
    },
  },
  {
    path: '/honda/contest',
    name: 'honda-contest',
    component: HomeView,
    meta: {
      layout: DefaultLayout,
      winners: false,
    },
  },
  {
    path: '/acura/contest',
    name: 'acura-contest',
    component: HomeView,
    meta: {
      layout: DefaultLayout,
      winners: false,
    },
  },
  {
    path: '/honda/national-winners',
    name: 'honda-national-winners',
    component: NationalWinnersView,
    meta: {
      layout: DefaultLayout,
      winners: true,
    },
  },
  {
    path: '/acura/national-winners',
    name: 'acura-national-winners',
    component: NationalWinnersView,
    meta: {
      layout: DefaultLayout,
      winners: true,
    },
  },
  {
    path: '/honda/winners',
    name: 'honda-winners',
    component: WinnersView,
    meta: {
      layout: DefaultLayout,
      winners: true,
    },
  },
  {
    path: '/acura/winners',
    name: 'acura-winners',
    component: WinnersView,
    meta: {
      layout: DefaultLayout,
      winners: true,
    },
  },
  {
    path: '/submission-review',
    name: 'submission-review',
    component: SubmissionReviewView,
    meta: {
      layout: BlankLayout,
    },
  },
  {
    path: '/waiver',
    name: 'waiver',
    component: EventWaiverView,
    meta: {
      layout: BlankLayout,
    },
  },
  {
    path: '/waiver-review',
    name: 'waiver-review',
    component: WaiverReviewView,
    meta: {
      layout: BlankLayout,
    },
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/',
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
